import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSeller } from '../../context/SellerContext';
import { sellerAuthAPI, handleAPIError } from '../../utils/sellerAPI';
import { auth } from '../../utils/firebase';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';

const SellerLogin = () => {
  const { setAuthData, setLoading, setError } = useSeller();
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [confirmationResult, setConfirmationResult] = useState(null);

  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container-login', {
        'size': 'invisible',
        'callback': (response) => {
          // reCAPTCHA solved
        }
      });
    }
  };

  const handleSendOTP = async () => {
    if (!mobileNumber || mobileNumber.length < 10) {
      setError('Please enter a valid mobile number');
      return;
    }

    setLoading(true);
    try {
      setupRecaptcha();
      const appVerifier = window.recaptchaVerifier;
      const phoneNumber = `+91${mobileNumber}`;

      const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      setConfirmationResult(confirmation);
      setOtpSent(true);
    } catch (err) {
      console.error("Error sending OTP:", err);
      setError(err.message);
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      setError('Please enter OTP');
      return;
    }

    if (!confirmationResult) {
      setError('Session expired. Please resend OTP.');
      return;
    }

    setLoading(true);
    try {
      // 1. Verify with Firebase
      const result = await confirmationResult.confirm(otp);
      const user = result.user;
      const idToken = await user.getIdToken();

      // 2. Verify with Backend
      const response = await sellerAuthAPI.verifyFirebaseToken(mobileNumber, idToken);

      setAuthData(response.data.token, response.data.seller);
      navigate('/seller/dashboard');
    } catch (err) {
      console.error("Error verifying OTP:", err);
      let message = err.message;
      if (err.response) {
        const apiError = handleAPIError(err);
        message = apiError.message;
      }
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#fff', padding: '40px' }}>
      <h2>Seller Login</h2>
      <div id="recaptcha-container-login"></div>

      <input
        type="text"
        placeholder="Mobile Number"
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
        disabled={otpSent}
      />
      {!otpSent ? (
        <button onClick={handleSendOTP}>Send OTP</button>
      ) : (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button onClick={handleVerifyOTP}>Verify OTP</button>
          <button
            onClick={() => {
              setOtpSent(false);
              setOtp('');
              if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
              }
            }}
            style={{ marginLeft: '10px', backgroundColor: '#ccc' }}
          >
            Change Number
          </button>
        </>
      )}
    </div>
  );
};

export default SellerLogin;
